import { type SelectProps } from 'antd'

import { PermissionTag } from '.'

export function getPermissionTagColor(permissionName: string) {
  if (permissionName.includes(':create:')) return 'green'
  if (permissionName.includes(':read:')) return 'blue'
  if (permissionName.includes(':update:')) return 'gold'
  if (permissionName.includes(':delete:')) return 'red'
  return 'default'
}

export const permissionTagRender: SelectProps['tagRender'] = (tagProps) => {
  const { label, closable, onClose } = tagProps

  return (
    <PermissionTag name={String(label)} closable={closable} onClose={onClose} />
  )
}
